import { render, staticRenderFns } from "./CampaignImagesForm.vue?vue&type=template&id=dec237d6&"
import script from "./CampaignImagesForm.vue?vue&type=script&lang=js&"
export * from "./CampaignImagesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports